module.exports = __webpack_public_path__ + "img/tablet.eddd2072.svg";